import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';
import { Button, Stack } from '@mui/material';

import { UseUndoRedoReturn } from 'hooks/useUndoRedo';

import { UndoRedoButtonGroup } from './PreviewControl.styled';

type PreviewControlsProps = {
    undoRedoActions: UseUndoRedoReturn['2'];
};

export const PreviewControls = ({
    undoRedoActions: { canRedo, canUndo, redo, undo },
}: PreviewControlsProps): JSX.Element => {
    return (
        <Stack spacing={2} direction="row" sx={{ ml: 'auto' }}>
            <UndoRedoButtonGroup variant="outlined" size="small">
                <Button disabled={!canUndo} onClick={() => undo()}>
                    <UndoIcon />
                </Button>
                <Button disabled={!canRedo} onClick={() => redo()}>
                    <RedoIcon />
                </Button>
            </UndoRedoButtonGroup>
        </Stack>
    );
};
